"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SimpleOfferList {
    constructor(simpleOffers) {
        this.simpleOffers = simpleOffers;
    }
    isEmpty() {
        return this.simpleOffers.length === 0;
    }
    getCount() {
        return this.simpleOffers.length;
    }
    hasListingOffers() {
        return this.simpleOffers.length > 0;
    }
    getFirstOffer() {
        return this.simpleOffers[0];
    }
    getOfferByIndex(index) {
        return this.simpleOffers[index];
    }
    getLastOffer() {
        return this.simpleOffers[this.getCount() - 1];
    }
    sortByCheapest() {
        this.simpleOffers.sort((a, b) => {
            const aCheapestPriceOffer = a.priceOfferList.getCheapestPriceOffer();
            const bCheapestPriceOffer = b.priceOfferList.getCheapestPriceOffer();
            if (aCheapestPriceOffer === null || bCheapestPriceOffer === null) {
                return 0;
            }
            return aCheapestPriceOffer.amount.withoutVat - bCheapestPriceOffer.amount.withoutVat;
        });
        return this;
    }
    sortByBestSelling() {
        this.simpleOffers.sort((a, b) => a.order - b.order);
        return this;
    }
    getCheapestSimpleOffer() {
        return this.sortByCheapest().getFirstOffer();
    }
    getMostExpensiveSimpleOffer() {
        return this.sortByCheapest().getLastOffer();
    }
    getUniqueColors() {
        const colors = [];
        this.simpleOffers.forEach((simpleOffer) => {
            simpleOffer.colors.forEach((color) => {
                const isInArray = colors.some((c) => c.basicColor === color.basicColor);
                if (isInArray === false) {
                    colors.push(color);
                }
            });
        });
        return colors;
    }
    getUniqueTrimNames() {
        const trimNames = [];
        this.simpleOffers.forEach((simpleOffer) => {
            trimNames.push(simpleOffer.trim);
        });
        return trimNames.filter((item, i, ar) => ar.indexOf(item) === i);
    }
    isAnySimpleOfferAvailableSooner() {
        return this.simpleOffers.find((simpleOffer) => simpleOffer.isAvailableSooner === true) !== undefined;
    }
    hasAnySimpleOfferWinterTires() {
        return this.simpleOffers.find((simpleOffer) => simpleOffer.hasWinterTires === true) !== undefined;
    }
    allOffersHaveSameAvailability() {
        return this.simpleOffers.every((simpleOffer) => simpleOffer.availabilityDescription === this.getFirstOffer().availabilityDescription);
    }
    getDataLayerGa4Data() {
        return JSON.stringify(this.simpleOffers.map((simpleOffer) => simpleOffer.dataLayer.ga4));
    }
}
exports.default = SimpleOfferList;
